export { default as CustomerQuotes } from './customerQuotes/customerQuotes'
export { default as DefaultAddress } from './address/DefaultAddress'
export { default as DefaultPayment } from './payment/DefaultPayment'
export { default as PressQuotes } from './pressQuotes/pressQuotes'
export { default as MirageMarkdown } from './markdown/markdown'
export * from './aboutUs'
export * from './accordion'
export * from './card'
export * from './contentful'
export * from './clotheslineAnimation'
export * from './emailCapture'
export * from './footer'
export * from './header'
export * from './images'
export * from './inputs'
export * from './layout'
export * from './product'
export * from './productTile'
export * from './sections'
export * from './slider'
export * from './social-media'
export * from './video'
export * from './paymentRequestForm'
export * from './couponCode'
export * from './referralSection'



// WEBPACK FOOTER //
// ./src/components/index.js